"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CHECKED = _spauiUtils.nodeTree.CHECKED;

var TreeBranchDomComponent = function TreeBranchDomComponent() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      onScroll = props.onScroll,
      _props$data = props.data,
      data = _props$data === void 0 ? [] : _props$data,
      _props$showBeginIndex = props.showBeginIndex,
      showBeginIndex = _props$showBeginIndex === void 0 ? 0 : _props$showBeginIndex,
      _props$children = props.children,
      children = _props$children === void 0 ? [] : _props$children,
      theNumberOfDisplay = props.theNumberOfDisplay,
      index = props.index,
      displayItemHeight = props.displayItemHeight,
      setBranchTitle = props.setBranchTitle,
      _props$branchTitleCla = props.branchTitleClassName,
      branchTitleClassName = _props$branchTitleCla === void 0 ? '' : _props$branchTitleCla,
      parentNode = props.parentNode,
      _props$classNameMap = props.classNameMap,
      classNameMap = _props$classNameMap === void 0 ? {} : _props$classNameMap,
      setBranchCheckAll = props.setBranchCheckAll; // 20是留点空间，避免真的就是跟展示数据一模一样，一样的话滚动的时候容易有问题

  var showPlacementDiv = data.length > theNumberOfDisplay + 20 && theNumberOfDisplay > 0;
  var title = (0, _spauiUtils.isFunction)(setBranchTitle) ? setBranchTitle(index, data, parentNode) : null;
  var checkAll = (0, _spauiUtils.isFunction)(setBranchCheckAll) ? setBranchCheckAll(index, data, parentNode) : undefined;

  var handleScroll = function handleScroll(event) {
    var triggerScrollCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (triggerScrollCallback && (0, _spauiUtils.isFunction)(onScroll)) {
      onScroll(event, index);
    }
  };

  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(className, _defineProperty({}, classNameMap.TreeScopeHaveTitleClassName, title)),
    style: style,
    onScroll: function onScroll(event) {
      return handleScroll(event, !title);
    }
  }, title ? _react["default"].createElement("div", {
    className: (0, _classnames["default"])(classNameMap.TreeScopeTitleClassName, branchTitleClassName)
  }, title) : null, showPlacementDiv ? _react["default"].createElement("div", {
    style: {
      height: showBeginIndex * displayItemHeight + 'px'
    }
  }) : null, _react["default"].createElement("ul", {
    className: "list-with-select",
    onScroll: function onScroll(event) {
      return handleScroll(event, title);
    }
  }, children.map(function (item, childIndex) {
    // 全选结构
    if (_typeof(item) === 'object' && item && item.props && item.props.checkAll) {
      if (typeof checkAll === 'undefined' && index > 0 || typeof checkAll !== 'undefined' && !checkAll) {
        return null;
      }
    }

    if (showPlacementDiv && (childIndex < showBeginIndex || childIndex > showBeginIndex + theNumberOfDisplay)) {
      return null;
    }

    return item;
  })), showPlacementDiv ? _react["default"].createElement("div", {
    style: {
      height: (data.length - (showBeginIndex + theNumberOfDisplay)) * displayItemHeight + 'px'
    }
  }) : null);
};
/**
 * 默认树状选择器Branch组件
 * @param props
 * @returns {XML}
 * @constructor
 */


var TreeBranchComponent = function TreeBranchComponent(_ref) {
  var parentNode = _ref.parentNode,
      branchWidthStyle = _ref.branchWidthStyle,
      BranchTreeNodeComponent = _ref.BranchTreeNodeComponent,
      onColumnScroll = _ref.onColumnScroll,
      theNumberOfDisplay = _ref.theNumberOfDisplay,
      displayItemHeight = _ref.displayItemHeight,
      setBranchTitle = _ref.setBranchTitle,
      branchTitleClassName = _ref.branchTitleClassName,
      _ref$classNameMap = _ref.classNameMap,
      classNameMap = _ref$classNameMap === void 0 ? {} : _ref$classNameMap,
      multiple = _ref.multiple,
      checkAll = _ref.checkAll,
      checkAllLabel = _ref.checkAllLabel,
      CheckAllComponent = _ref.CheckAllComponent,
      valueTreeNodeMap = _ref.valueTreeNodeMap,
      _ref$checkAllProps = _ref.checkAllProps,
      checkAllProps = _ref$checkAllProps === void 0 ? {} : _ref$checkAllProps,
      _ref$nodeNotAllowSele = _ref.nodeNotAllowSelected,
      nodeNotAllowSelected = _ref$nodeNotAllowSele === void 0 ? false : _ref$nodeNotAllowSele,
      setBranchCheckAll = _ref.setBranchCheckAll;
  var isAllSelected = parentNode.status === CHECKED;
  var childrenNodes = parentNode && parentNode.childrenNodes && parentNode.childrenNodes || [];

  var onScroll = function onScroll(event, index) {
    if ((0, _spauiUtils.isFunction)(onColumnScroll) && event.target) {
      var scrollTop = event.target.scrollTop;
      var visibleHeight = event.target.clientHeight;
      var scrollHeight = event.target.scrollHeight;
      onColumnScroll(event, parentNode, [scrollTop, scrollTop + visibleHeight], scrollHeight, childrenNodes, index);
    }
  }; // 如果父节点是选中状态, 那么子节点全选中
  // 同时 不展示选中的动画, 防止闪动


  var customClassName = (0, _classnames["default"])(classNameMap.TreeScopeClassName, {
    'noanimation': isAllSelected
  }); // 判断是否选中

  var isChecked = function isChecked() {
    var result = false,
        ok = false;

    if ((0, _spauiUtils.isArray)(childrenNodes) && childrenNodes.length > 0) {
      result = true;
      childrenNodes.map(function (item) {
        if (item && !item.disabled && !item.not_allow_selected && (item.value || typeof item.value === 'number') && !(typeof item.isAllowSelected !== 'undefined' && !item.isAllowSelected)) {
          if (item.status !== CHECKED) {
            result = false;
          }

          ok = true;
        }

        return item;
      }); // 如果没有一列是ok的，那就要重新变成false

      if (!ok) {
        result = false;
      }
    }

    return result;
  };

  var isIndeterminate = function isIndeterminate() {
    var result = false;

    if (!isChecked() && (0, _spauiUtils.isArray)(childrenNodes) && childrenNodes.length > 0) {
      childrenNodes.map(function (item) {
        if (item && item.status === CHECKED) {
          result = true;
        }

        return item;
      });
    }

    return result;
  };

  return _react["default"].createElement(TreeBranchDomComponent, {
    classNameMap: classNameMap,
    className: customClassName,
    style: branchWidthStyle,
    onScroll: onScroll,
    parentNode: parentNode,
    data: childrenNodes,
    theNumberOfDisplay: theNumberOfDisplay,
    displayItemHeight: displayItemHeight,
    setBranchTitle: setBranchTitle,
    setBranchCheckAll: setBranchCheckAll,
    branchTitleClassName: branchTitleClassName
  }, multiple && checkAll && !nodeNotAllowSelected ? _react["default"].createElement(CheckAllComponent, _extends({}, checkAllProps, {
    checked: isChecked(),
    indeterminate: isIndeterminate(),
    valueTreeNodeMap: valueTreeNodeMap,
    checkAll: checkAll,
    checkAllLabel: checkAllLabel,
    data: childrenNodes
  })) : null, // 同步触发下渲染子结构
  childrenNodes.map(function (item) {
    return BranchTreeNodeComponent(item);
  }));
};

var _default = TreeBranchComponent;
exports["default"] = _default;